import PricingCalendar from './pricing/PricingCalendar';

Vue.component('inventory-pricing', {
    props: ['categories'],
    components: { PricingCalendar },
    data() {
        return {
            emailForm: new SparkForm({
                email: null,
            }),
        };
    },
});
